import { render, staticRenderFns } from "./StatuDetail.vue?vue&type=template&id=5d7cadae&"
import script from "./StatuDetail.vue?vue&type=script&lang=js&"
export * from "./StatuDetail.vue?vue&type=script&lang=js&"
import style0 from "./StatuDetail.vue?vue&type=style&index=0&rel=stylesheet%2Fless&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports